import { ImpedimentGroup } from '../api/app-types/impediment.app';

export const mockImpedimentGroups: ImpedimentGroup[] = [
	{
		id: 1,
		description: 'Finanzierung',
		impediments: [
			{ id: 11, description: 'Leistungen noch unklar' },
			{ id: 12, description: 'Zuständigkeit ungeklärt' },
		],
	},
	{
		id: 2,
		description: 'Organisation',
		impediments: [
			{ id: 21, description: 'Fehlende Unterlagen' },
			{ id: 22, description: 'Termin steht noch aus' },
		],
	},
];
